import { FC } from "react";
import { Button } from "@mui/material";
import { MdOutlineAutoFixHigh } from "react-icons/md";

interface Props {
  type: "summary" | "full";
  onClick: () => void;
  sx?: any;
}

const ProfileNavigationButton: FC<Props> = ({ type, onClick, sx = {} }) => {
  const isSummary = type === "summary";

  return (
    <Button
      variant="contained"
      startIcon={isSummary ? <MdOutlineAutoFixHigh /> : undefined}
      onClick={onClick}
      sx={{
        backgroundColor: "#000094",
        color: "white",
        borderRadius: "8px",
        padding: "8px 12px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        fontFamily: "Source Sans Pro, sans-serif",
        textTransform: "none",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        "&:hover": {
          backgroundColor: "#000080",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
        },
        "& .MuiButton-startIcon": {
          marginRight: "8px",
        },
        ...sx,
      }}
    >
      {isSummary ? "Go to AI Summary Profile" : "Go to Full Profile"}
    </Button>
  );
};

export default ProfileNavigationButton;
